<template>
  <div class="article-3">
    <div class="article__info">
      <h1 class="article__title"><span>王定宇、彭文正 綠營鬧分裂</span><span>極統vs極獨 洪秀柱求逆轉勝</span></h1>
      <div class="article__reporter">聯合報 記者：修瑞瑩、唐秀麗、周宗禎／報導</div>
    </div>
    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-3-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">洪秀柱可能同時對上王定宇、彭文正，形成一場極統vs極獨的選戰。記者陳柏亨、胡經周／攝影</figcaption>
    </figure>
    <p class="article__paragraph">國民黨提名前主席洪秀柱參選台南市立委，對上本屆第一高票的民進黨現任立委王定宇，洪秀柱若是能打一場「空戰+陸戰」，加上綠營可能面臨分裂的局勢，最後有機會逆轉藍綠勢力。</p>
    <p class="article__paragraph">洪秀柱南下參選態勢底定，接著傳出台大前教授<Dictionary word="彭文正" meaning="臺灣媒體工作者及新聞學者，曾任台灣大學教授，主持《政經看民視》，並與其妻李晶玉主持《政經關不了》，同時是喜樂島的重要成員。"/>要披上喜樂島戰袍，加入當地立委選戰這一役。熟悉當地選情人士分析，喜樂島不僅設在台南，現任黨主席更是東區長老教會牧師羅仁貴，這陣子一直在評估，如何布局下屆立委選舉。</p>
    <p class="article__paragraph">地方政黨人士說，國民黨確定提名洪秀柱，而且洪秀柱接受媒體訪問時，不時談到「一中同表」，等於讓喜樂島撿到衝鋒槍，可望上演一場「極統對上極獨」，藉此大幅拉高喜樂島的選情，並且衝高政黨票。</p>
    <p class="article__paragraph">地方大老說，在喜樂島刻意操作下，綠營將陷入分裂危機。</p>

    <h2 class="article__subtitle">向新系靠攏<br/>非新系不滿王定宇</h2>

    <p class="article__paragraph">民進黨人士指出，王定宇在本屆立委選舉，衝出全國第一高票，現在因為選區調整，選情受到衝擊，而王定宇又向新潮流派系靠攏，甚至與新系其他選區參選人林宜瑾一起成立服務處，引發非新系的不滿。</p>
    <p class="article__paragraph">地方人士分析，王定宇昔日高舉台獨旗幟，但獨派自組政黨喜樂島，派出高知名度的彭文正，遇上洪秀柱同樣也有全國知名度，而且色彩鮮明，過去這兩人雖未在台南經營選區，但洪秀柱與彭文正相互空戰，邊緣化王定宇之際，洪秀柱還可趁機重整藍營選票。</p>
    <p class="article__paragraph">空戰方面，地方人士提醒，王定宇過去挺同，遭受選區內教會系統的反彈，如果反同立場的洪秀柱，未來若主攻王定宇的挺同立場，也可在深綠選區拿到傳統家庭的支持。</p>

    <h2 class="article__subtitle">柱姐喚醒沉默藍營<br/>空戰+陸戰 挑戰不可能任務</h2>

    <p class="article__paragraph">地面部隊的組織戰上，國民黨務人士說，洪秀柱上屆參選總統，與台南國民黨議員林燕祝、王家貞等人，早已建立革命情感，東區29里偏藍，加上仁德眷村票等，都能較具優勢。</p>
    <p class="article__paragraph">東區選出的國民黨議員王家貞說，洪秀柱表達南下參選，「挑戰不可能的任務」後，激勵許多「沉默多年的藍軍」，原本綠到出汁的仁德等選區，都有人主動跳出來協助，加上本屆市長選舉時，代表國民黨的高思博在敗選後舉家南遷，深耕台南，也將給洪秀柱一臂之力。</p>
  </div>
</template>

<script>
import Dictionary from '@/components/Dictionary'

export default {
  name: 'Article3',
  components: {
    Dictionary
  }
}
</script>

<style lang="scss">
.article-3 {
}
</style>
